/*
 * Copyright (c) 2025 Antmicro <www.antmicro.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 */
const globalProperties = {
    softLoad: false,
};
export default globalProperties;
